const regionDefault = 'es-AR';

function formatRoundedCurrency(
  amount: number,
  region: string = regionDefault
): string {
  return new Intl.NumberFormat(region).format(Math.round(amount));
}
export default formatRoundedCurrency;
